import type { ReactElement } from "react";

import {
    StyledAccuracyGradeText,
    StyledBaseCell,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/components/cells/ContactAccuracyGradeCell/styles";

interface IProps {
    value?: string;
}

const ContactAccuracyGradeCell = ({ value }: IProps): ReactElement => {
    return (
        <StyledBaseCell>
            <StyledAccuracyGradeText fontVariant="sectionTitle">{value}</StyledAccuracyGradeText>
        </StyledBaseCell>
    );
};

export default ContactAccuracyGradeCell;
